
import Api from './Api.service';
export default class VersionesAppService {
    
    static ObtenerVersiones(token) {
        return Api.get(`app/versiones`);
    }
    
    static NewApp(formData) {
        return Api.post("app/new", formData);
    }

    static EditApp(versionId,formData) {
        return Api.put(`app/version/${versionId}`, formData);
    }
   

}